/**
 * session 存储
 */
export default {
    getUserName: function () {
        return sessionStorage.getItem('userName');
    },
    setUserName: function (userName) {
        sessionStorage.setItem('userName', userName);
    },

    getUserId: function () {
        return sessionStorage.getItem('userId');
    },
    setUserId: function (userId) {
        sessionStorage.setItem('userId', userId);
    },

    getMobile: function () {
        return sessionStorage.getItem('mobile');
    },
    setMobile: function (mobile) {
        sessionStorage.setItem('mobile', mobile);
    },
    // h5人脸识别
    getVerifyToken: function () {
        return sessionStorage.getItem('verifyToken');
    },
    setVerifyToken: function (verifyToken) {
        sessionStorage.setItem('verifyToken', verifyToken);
    },
    getAccessToken: function () {
        return sessionStorage.getItem('accessToken');
    },
    setAccessToken: function (accessToken) {
        sessionStorage.setItem('accessToken', accessToken);
    },

    getHeadPicture: function () {
        return sessionStorage.getItem('headPicture');
    },
    setHeadPicture: function (headPicture) {
        sessionStorage.setItem('headPicture', headPicture);
    },

    getBaseId: function () {
        return sessionStorage.getItem('baseId');
    },
    setBaseId: function (baseId) {
        sessionStorage.setItem('baseId', baseId);
    },

    getBaseName: function () {
        return sessionStorage.getItem('baseName');
    },
    setBaseName: function (baseName) {
        sessionStorage.setItem('baseName', baseName);
    },
    getUserType: function () {
        return sessionStorage.getItem('userType');
    },
    setUserType: function (userType) {
        sessionStorage.setItem('userType', userType);
    },
    getMyMenus: function () {
        var menus = sessionStorage.getItem('menus');
        return JSON.parse(menus);
    },
    setMyMenus: function (menus) {
        sessionStorage.setItem('menus', JSON.stringify(menus));
    },
    getRealName: function () {
        return sessionStorage.getItem('realName');
    },
    setRealName: function (realName) {
        sessionStorage.setItem('realName', realName);
    },

    getUserPictureUrl: function () {
        return sessionStorage.getItem('userPictureUrl');
    },

    setUserPictureUrl: function (userPictureUrl) {
        sessionStorage.setItem('userPictureUrl', userPictureUrl);
    },

    getIsSuperAdmin: function () {
        return sessionStorage.getItem('isSuperAdmin');
    },
    setIsSuperAdmin: function (isSuperAdmin) {
        sessionStorage.setItem('isSuperAdmin', isSuperAdmin);
    },
    getIdcard: function () {
        return sessionStorage.getItem('idcard');
    },
    setIdcard: function (idcard) {
        sessionStorage.setItem('idcard', idcard);
    },
    clearSession: function () {
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('userId');
        sessionStorage.removeItem('mobile');
        sessionStorage.removeItem('userPictureUrl');
        sessionStorage.removeItem('baseId');
        sessionStorage.removeItem('baseName');
        sessionStorage.removeItem('userType');
        sessionStorage.removeItem('menus');
        sessionStorage.removeItem('realName');
        sessionStorage.removeItem('isSuperAdmin');
        sessionStorage.removeItem('idcard');
        sessionStorage.removeItem('accessToken');
        sessionStorage.removeItem('verifyToken');
    },
    initSession: function (data) {
        if (typeof (data) != 'undefined' && typeof (data.userId) != 'undefined' && data != null && data.userId != null) {
            sessionStorage.setItem('userName', data.userName);
            sessionStorage.setItem('userId', data.userId);
            sessionStorage.setItem('mobile', data.mobile);
            sessionStorage.setItem('userPictureUrl', data.userPictureUrl);
            sessionStorage.setItem('baseId', data.baseId);
            sessionStorage.setItem('baseName', data.basesName);
            sessionStorage.setItem('userType', data.userType);
            sessionStorage.setItem('menus', JSON.stringify(data.menus));
            sessionStorage.setItem('realName', data.realName);
            sessionStorage.setItem('isSuperAdmin', data.superAdmin);
            sessionStorage.setItem('idcard', data.idCard);
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/sessionStore.js